import React from 'react';
import ReactDOM from 'react-dom/client';
import _ from 'lodash';
import MosaicDndItem from './MosaicDndItem';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, horizontalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';

/**
 * @typedef {object} MosaicDndProps
 * @property {string} modelName - Le nom du modèle des items à afficher
 * @property {Array<any>} items - La liste des items à afficher
 * @property {string} apiUrl - L'url de l'api pour récupérer les items
 */

class MosaicDnd extends React.Component {

  /**
   * Constructeur du composant MosaicDnd
   * @param {any} props - Propriétés du composant
   */
  constructor(props) {
    super(props);

    this.state = /** @type {MosaicDndProps}*/ ({
      modelName: props.modelName,
      items: [],
      apiUrl: props.apiUrl
    });
  }

  async componentDidMount() {
    var items = await this.fetchItems();

    this.setState({
      items
    });
  }

  /**
   * Chargement des items via l'api
   * @returns {Promise<Array<any>>} La liste des items chargés via l'api
   */
  async fetchItems() {
    var response = await fetch(this.state.apiUrl, {
        headers: {
          Authorization: "gestiaweb"
        }
      });

    return await response.json();
  }

  /**
   * Permet de mettre à jour la position des items après un drag and drop
   * @returns {Promise<Array<any>>} La liste des items à jour
   */
  async updateItems() {
    var response = await fetch(`/api/update/${this.state.modelName}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: this.state.items,
        property: 'position',
        modelName: this.state.modelName
      })
    });

    return await response.json();
  }

  /**
   * Evénement lors du drag end de l'item
   * @param {import('@dnd-kit/core').DragEndEvent} event - Objet résultant du drag and drop
   * @returns Ne fait pas de traitement spécifique si on ne change pas de position
   */
  async onDragEnd(event) {
    var { active, over } = event,
      items = this.state.items,
      draggingIndexItem = items.findIndex(item => {
        return item.id === active.id;
      }),
      droppingIndexItem = items.findIndex(item => {
        return over && item.id === over.id;
      }),
      newItems = arrayMove(items, draggingIndexItem, droppingIndexItem);

    newItems = newItems.map((item, index) => {
      item.position = index + 1;
      return item;
    });

    this.setState({
      items: newItems
    });

    await this.updateItems();
  }

  render() {
    var style = {
      display: 'flex',
      gap: '8px'
    };

    return (
      <div style={style}>
        <DndContext onDragEnd={this.onDragEnd.bind(this)}>
          <SortableContext collisionDetection={closestCenter} items={this.state.items} strategy={horizontalListSortingStrategy}>
            {this.state.items.map((item, index) => (
              <MosaicDndItem key={item.id} item={item} modelName={this.state.modelName} />
            ))}
          </SortableContext>
        </DndContext>
      </div>
    );
  }
}

var mosaicDndNode = document.getElementById('mosaic-dnd');
if (mosaicDndNode) {
  var root = ReactDOM.createRoot(mosaicDndNode);
  root.render(<MosaicDnd modelName={mosaicDndNode.getAttribute('data-modelname')} apiUrl={mosaicDndNode.getAttribute('data-apiurl')}/>);
}
